var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-remove',{attrs:{"type":"gallery","name":_vm.gallery.name,"on-remove":_vm.onRemove},on:{"close":function($event){return _vm.$emit('close')}}},[_c('p',[_vm._v("This will also remove the photo’s in the gallery.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }